
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import './App.css';
import Layout from "./layout";
import LiveStreaming from "./pages/liveStreaming";
import Dashboard from "./pages/dashboard";
import EventsCalendar from "./pages/eventsCalendar";
import CreateEvent from "./pages/createEvent";
import Forms from "./pages/forms";
import CreateForms from "./pages/createForm";
import Groups from "./pages/groups";
import CreateGroup from "./pages/createGroup";
import Members from "./pages/members";
import CreateMember from "./pages/createMember";
import StartStream from "./pages/startStream";
import StreamViewer from "./pages/streamViewer";
import EditEvent from "./pages/editEvent";
import EditForm from "./pages/editForms";
import EditGroup from "./pages/editGroup";
import ViewMember from "./pages/viewMember";
import Donations from "./pages/donations";
import PrayerWall from "./pages/prayerWall";
import Testimonies from "./pages/testimonies";
import Serving from "./pages/serving";
import SetDuties from "./pages/setDuties";
import MemberAtt from "./pages/memberAtt";
import ProtectedRoute from "./firebase/protectedRoute";
import Login from "./pages/login";

function App() {
  return (
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Login/>} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
              }>
              {/* <Route path="/dahsboard" element={<Dashboard/>} /> */}
              <Route path="/live-streaming" element={<LiveStreaming/>} />
              <Route path="/events-calendar" element={<EventsCalendar/>} />
              <Route path="/add-event" element={<CreateEvent/>} />
              <Route path="/forms-builder" element={<Forms/>} />
              <Route path="/create-a-form" element={<CreateForms/>} />
              <Route path="/groups" element={<Groups/>} />
              <Route path="/create-a-group" element={<CreateGroup/>} />
              <Route path="/members" element={<Members/>} />
              <Route path="/donations" element={<Donations/>} />
              <Route path="/prayer-wall" element={<PrayerWall/>} />
              <Route path="/serving" element={<Serving/>} />
              <Route path="/testimonies" element={<Testimonies/>} />
              <Route path="/add-a-member" element={<CreateMember/>} />
              <Route path="/start-stream" element={<StartStream/>} />
              <Route path={`/edit-event/:eventTitle`} element={<EditEvent/>} />
              <Route path={`/edit-form/:formTitle`} element={<EditForm/>} />
              <Route path={`/edit-group/:groupId`} element={<EditGroup/>} />
              <Route path={`/members/:memberId`} element={<ViewMember/>} />
              <Route path={`/:currentMonth/:groupId`} element={<SetDuties/>} />
            </Route> 
            <Route path="/member-attendance" element={<MemberAtt/>} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
